import React from 'react'

const Events: React.FC = () => {
    return (
        <section className="page-section bg-light" id="portfolio">
            <div className="container">
                <div className="text-center">
                    <h2 className="section-heading text-uppercase" style={{ color: '#000' }}>
                        Our Events
                    </h2>
                </div>

                <div className="row g-4 mb-5 align-items-start">
                    <div className="col-12 col-md-6">
                        <img
                            src="./img/events/2026/fall/Sep2026GameNightFlyer.png"
                            alt="Old School Game Night on September 19, 2026"
                            className="img-fluid w-100"
                        />
                    </div>
                    <div className="col-12 col-md-6">
                        <img
                            src="./img/events/2026/fall/midwestlitauthor.png"
                            alt="Midwest LitFest meet and greet with author Keenan Jones on October 3"
                            className="img-fluid w-100"
                        />
                    </div>
                </div>

                <div data-tockify-component="calendar" data-tockify-calendar="houseevents"></div>
            </div>
        </section>
    )
}

export default Events
